import { render, staticRenderFns } from "./backButton.vue?vue&type=template&id=8f2f26b8"
import script from "./backButton.vue?vue&type=script&lang=js"
export * from "./backButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports